// @ts-nocheck
import { FRONTEND_CONFIG } from "./configs";

export const DEFAULT_ESTIMATE_NAME = "Event Estimate";
export const DEFAULT_INVOICE_NAME = "Event Invoice";

export const CONTRACT_STATUS = {
  SENT: "sent",
  REVIEW: "review",
  VERIFIED: "verified",
  DISCARDED: "discarded",
  ARCHIVE: "archive",
};

export const FLAG_BUTTON_NAME = "Flag Contractor";
export const UNFLAG_BUTTON_NAME = "Unflag Contractor";

export const RESTRICT_BUTTON_NAME = "Restrict Contractor";
export const UNRESTRICT_BUTTON_NAME = "Unrestrict Contractor";

export const RESTRICT_ALERT_MESSAGE =
  "This contractor is restricted and you won't be able to assign this contractor to this event.";

export const RESTRICT_ALERT_MESSAGE_SEND_OPP =
  "This contractor is restricted and you won't be able to send this contractor any opportunities.";

export const UNFLAG_ALERT_MESSAGE =
  "This contractor is flagged. The requested action cannot be completed.";

/**
 * contractor types
 */
export const CONTRACTOR_TYPE_3RD_PARTY = {
  OUTSOURCED: "outSource",
  THIRD_PARTY: "thirdParty",
};

// /**
//  * travel days constants
//  */
// export const TRAVEL_DAYS = {
//   TRAVEL_DAY_TYPE: {
//     PROCEEDING_POSITION: "proceedingPosition",
//     FOLLOWING_POSITION: "followingPosition",
//     BOTH: "both",
//   },
//   NUMBER_OF_DAYS: {
//     ONE: "1",
//     TWO: "2",
//     THREE: "3",
//   },
//   RATE_TYPE: {
//     FULL_DAY: "fullDay",
//     HALF_DAY: "halfDay",
//     CUSTOM_AMOUNT: "custom",
//   },
//   CUSTOM_AMOUNT_TYPE: {
//     PER_DAY: "perDay",
//     LUMP_SUM: "lumpSum",
//   },
//   CHARGES_APPLIED_TO: {
//     CONTRACTOR_ONLY: "contractor",
//     CUSTOMER_ONLY: "customer",
//     BOTH: "both",
//   },
// };

export const TIER_TITLES = {
  clientAppliedTier1: "Tier 1",
  clientAppliedTier2: "Tier 2",
  clientAppliedTier3: "Tier 3",
  clientAppliedPremiumTier: "Premium Tier",
  ...(FRONTEND_CONFIG.budgetTier
    ? {
        clientAppliedBudgetTier: "Budget Tier",
      }
    : {}),
};